var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e5487df720ff0cc89ae4fb2967724f8bd3c136b1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@higher-learning-technologies"]={id:"e5487df720ff0cc89ae4fb2967724f8bd3c136b1"};
      